import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 40px 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 445px;
  border-radius: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 25px 10px;
  }
`;

export const SuccessIcon = styled.div`
  width: 35px;
  height: 35px;
  background-image: url('/images/check-circle-rounded.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 24px;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 20px 0;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const ModalDescription = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin: 0 0 30px 0;
`;

export const ModalButton = styled.button`
  background: ${({ theme }) => theme.palette.system.blue};
  color: ${({ theme }) => theme.palette.system.white};
  border: none;
  border-radius: 14px;
  padding: 16px;
  font-size: 15px;
  cursor: pointer;
  width: 100%;
`;
